import { cdn } from "common/utils/cdn"

import Style from "./index.module.scss"

const EmptyYet = () => {
	return (
		<div className={Style.emptyYet}>
			<img src={`${cdn()}/images/index/empty.png`} alt="empty" />
			<span>No data yet</span>
		</div>
	)
}

export default EmptyYet
